<template>
  <div class="profile-container">
    <h2 class="profile-title">Profil</h2>
    <div class="navigation-container">
      <div class="main-title"><h2>Genveje</h2></div>
      <div class="navigation-profile">
        <a v-for="view in views" v-bind:key="view.key" v-bind:class="['view-button', {active: currentView === view.key}]" v-on:click="currentView = view.key" v-bind:href="'#/' + view.key">
          {{ view.label }}
        </a>
        <a :href="$settings.logOutUrl">Log ud</a>
      </div>
    </div>

    <component v-show="!loading" v-on:loaded="loading = false" v-bind:is="currentViewComponent" class="view"></component>

    <div v-show="loading" class="full-width-loading">
      <loading></loading>
    </div>
  </div>
</template>

<script>
import Dashboard from 'Components/Views/Dashboard'
import User from 'Components/Partials/User'
import PaymentCards from 'Components/Partials/PaymentCards'
import Transactions from 'Components/Partials/Transactions'
import Loading from 'Components/Partials/Loading'
import ClaimCashback from 'Components/Partials/ClaimCashback'

export default {
  name: 'Account',

  components: {
    'view-dashboard': Dashboard,
    'view-user': User,
    'view-payment-cards': PaymentCards,
    'view-transactions': Transactions,
    'view-claim-cashback': ClaimCashback,
    'loading': Loading,
  },

  data() {
    return {
      loading: true,
      currentView: 'dashboard',
      views: [
        {
          label: 'Oversigt',
          key: 'dashboard',
        },
        {
          label: 'Mine oplysninger',
          key: 'user',
        },
        {
          label: 'Mine kort',
          key: 'payment-cards',
        },
        {
          label: 'Kontobevægelser',
          key: 'transactions',
        },
        {
          label: 'Efterregistrer',
          key: 'claim-cashback',
        },
      ],
    }
  },

  created() {
    // Handle "deep linking"
    let view = window.location.hash.substr(2)

    if (view && this.viewExists(view)) {
      this.currentView = view
    }
  },

  mounted() {
    window.addEventListener('hashchange', (data) => {
      this.currentView = window.location.hash.substr(2)
    })
  },

  methods: {
    viewExists(requestedView) {
      let exists = false

      this.views.forEach((view) => {
        if (requestedView == view.key) {
          exists = true
        }
      })

      return exists
    },
  },

  computed: {
    currentViewComponent: function () {
      this.loading = true
      return 'view-' + this.currentView
    },
  },
}
</script>
